/* Model */
class TicketModel extends App.Models.BaseModel {
  modelUrl = 'Ticket';
}

App.Models.Ticket = TicketModel;

/* Collection */
class TicketCollection extends App.Collections.BaseCollection {
  url = 'Ticket';
  model = App.Models.Ticket;
}

App.Collections.Tickets = TicketCollection;

/* Router */
class TicketRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'Ticket';
    const model = App.Models.Ticket;
    const collectionClass = App.Collections.Tickets;

    super(entityName, model, collectionClass);

    (function removePermissionToCreateAndUpdate() {
      if (Monet?.Session?.Security?.permissions) {
        const permissions = Monet?.Session?.Security?.permissions
          .filter(permission => permission.key !== 'TICKET_CREATE')
          .filter(permission => permission.key !== 'TICKET_UPDATE');
    
        Monet.Session.Security.permissions = permissions;
      }
    })();

    (function addPermissionToScreen() {
      if (Monet?.Session?.Security?.screens) {
        Monet.Session.Security.screens.push('/ticket');
      }
    })();
  }

  beforeList = () => {
    const grid = App.Forms.Ticket.table;
    const menu = new Greenmile.Ticket.Grid.Menu();

    menu.setListenersTo(grid);
  }
}

App.Routers.Ticket = TicketRouter;